import { SOCKET, decodedOrRaw, legField, SectionCard, FactGrid, ProtocolValue, ProtocolParamList, fieldAtPath } from './chunk-NNFGQV3X.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var LABELS = {
  bridge: "Bridge via Socket Open Router",
  swap: "Swap via Socket Open Router",
  swapAndBridge: "Swap and bridge via Socket Open Router",
  performActions: "Socket Open Router actions"
};
var SIGNATURES = {
  bridge: "bridge(bytes32,(address,address,uint256),(address,uint256),(address,address,uint256),bytes)",
  swap: "swap(bytes32,uint256,(address,address,uint256),(address,uint256),(address,address,address,uint256,uint256,uint256),bytes,address)",
  swapAndBridge: "swapAndBridge(bytes32,uint256,(address,address,uint256),(address,uint256),(address,address,address,uint256,uint256,uint256),bytes,(address,address,uint256),bytes)",
  performActions: "performActions(bytes32,(uint256,bytes,uint256[])[])"
};
function SocketRoute({ call, hint }) {
  const get = (name) => fieldAtPath(call.params, name);
  const input = get("input");
  const actions = decodedOrRaw(get("actions"));
  const hasSplices = Array.isArray(actions) && actions.some((action) => {
    const splices = decodedOrRaw(legField(action, "splices"));
    return Array.isArray(splices) && splices.length > 0;
  });
  const bridge = get("bridgeData");
  const swap = get("swapData");
  const fields = [
    ["Requested by", legField(input, "user")],
    ["Input token", legField(input, "inputToken")],
    ["Input amount (base units)", legField(input, "inputAmount")],
    ["Swap target", legField(swap, "target")],
    ["Bridge target", legField(bridge, "target")],
    ["Swap receiver", get("receiver")],
    ["Quote ID", get("quoteId")]
  ];
  return /* @__PURE__ */ jsxs(SectionCard, { title: hint.label ?? LABELS[call.label ?? ""] ?? "Socket Open Router", protocolId: SOCKET.protocolId, children: [
    /* @__PURE__ */ jsx(FactGrid, { facts: fields.map(([label, value]) => ({
      label,
      value: /* @__PURE__ */ jsx(ProtocolValue, { value }),
      when: value != null
    })) }),
    Array.isArray(actions) && /* @__PURE__ */ jsxs("p", { className: "mt-2 text-xs", children: [
      actions.length,
      " routed ",
      actions.length === 1 ? "action" : "actions"
    ] }),
    hasSplices && /* @__PURE__ */ jsx("p", { className: "mt-2 text-xs text-muted-foreground", children: "Some action data uses earlier return values. Its template bytes alone do not establish the executed amounts or effects." }),
    bridge != null && /* @__PURE__ */ jsx("p", { className: "mt-2 text-xs text-muted-foreground", children: "Follow the underlying bridge message to check destination delivery. The quote ID is a caller-supplied reference." }),
    /* @__PURE__ */ jsxs("details", { className: "mt-3 min-w-0", children: [
      /* @__PURE__ */ jsx("summary", { className: "cursor-pointer text-xs text-muted-foreground", children: "Route calls and arguments" }),
      /* @__PURE__ */ jsx("div", { className: "pt-2", children: /* @__PURE__ */ jsx(ProtocolParamList, { params: call.params, emptyLabel: "No decoded arguments" }) })
    ] })
  ] });
}
function SocketExecuted({ event }) {
  return /* @__PURE__ */ jsxs(SectionCard, { title: "Socket routing request executed", protocolId: SOCKET.protocolId, children: [
    /* @__PURE__ */ jsx("p", { className: "mb-2 text-xs text-muted-foreground", children: "The router completed its calls on this chain. A bridge route needs separate destination evidence." }),
    /* @__PURE__ */ jsx(FactGrid, { facts: [{ label: "Quote ID", value: /* @__PURE__ */ jsx(ProtocolValue, { value: fieldAtPath(event.params, "quoteId") }) }] })
  ] });
}
var SOCKET_HINTS = {
  valueHints: [],
  callHints: Object.entries(LABELS).map(([call, label]) => ({
    protocolId: SOCKET.protocolId,
    call,
    signature: SIGNATURES[call],
    component: "SocketRoute",
    label,
    summaryFields: []
  })),
  eventHints: [{ protocolId: SOCKET.protocolId, event: "RequestExecuted", component: "SocketExecuted", summaryFields: [] }]
};
function registerSocket(registry) {
  registry.registerCall("SocketRoute", SocketRoute);
  registry.registerEvent("SocketExecuted", SocketExecuted);
  registry.registerHints(SOCKET_HINTS);
  return registry;
}

export { SOCKET_HINTS, SocketExecuted, SocketRoute, registerSocket };
//# sourceMappingURL=chunk-A5LEUT5M.js.map
//# sourceMappingURL=chunk-A5LEUT5M.js.map